import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import AdherentLayout from '../layouts/AdherentLayout';
import { AuthGuard, RoleGuard, MemberGuard } from '../guards';
import Login from '../components/Login';
import AdherentLogin from '../pages/auth/AdherentLogin';
import AdherentDashboard from '../pages/adherent/AdherentDashboard';
import AdherentProfile from '../pages/adherent/AdherentProfile';
import AdherentMemberships from '../pages/adherent/AdherentMemberships';



// Admin Pages
import DashboardPage from '../pages/admin/DashboardPage';
import UsersPage from '../pages/admin/UsersPage';
import RolesPage from '../pages/admin/RolesPage';
import PermissionsPage from '../pages/admin/PermissionsPage';

import InfoPage from '../pages/admin/InfoPage';
import AlbumListPage from '../pages/admin/albums/AlbumListPage';
import AlbumCreatePage from '../pages/admin/albums/AlbumCreatePage';
import AlbumUploadPage from '../pages/admin/albums/AlbumUploadPage';
import EvenementListPage from '../pages/admin/EvenementListPage';
import EvenementFormPage from '../pages/admin/EvenementFormPage';
import AdhesionListPage from '../pages/admin/AdhesionListPage';
import PresentationEditPage from '../pages/admin/PresentationEditPage';
//Public Pages
import Accueil from '../pages/public/Accueil';
import Actualite from '../pages/public/Actualite';
import Presentation from '../pages/public/Presentation';
import Evenement from '../pages/public/Evenement';
import Publication from '../pages/public/Publication';
import Galerie from '../pages/public/Galerie';
import Contact from '../pages/public/Contact';
import Adhesion from '../pages/public/Adhesion';
import PublicLayout from '../layouts/PublicLayout';
import HomepageContent from '../pages/admin/HomepageContent';
import EvenementDetail from '../pages/public/EvenementDetail';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <Accueil />,
      },
      {
        path: 'Presentation',
        element: <Presentation />,
      },
      {
        path: 'Actualite',
        element: <Actualite />,
      },
      {
        path: 'Evenement',
        element: <Evenement />,
      },
      {
        path: 'Evenement/:id',
        element: <EvenementDetail />,
      },
      {
        path: 'Publication',
        element: <Publication />,
      },
      {
        path: 'Galerie',
        element: <Galerie />,
      },
      {
        path: 'Contact',
        element: <Contact />,
      },
      {
        path: 'adhesion',
        element: <Adhesion />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'adherent-login',
        element: <AdherentLogin />,
      },

    ],
  },
  {
    path: '/dashboard',

  },
  {
    path: '/adherent',
    element: (
      <AuthGuard>
        <RoleGuard requiredRoles={['adherent']}>
          <AdherentLayout />
        </RoleGuard>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/adherent/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <AdherentDashboard />,
      },
      {
        path: 'profile',
        element: <AdherentProfile />,
      },
      {
        path: 'memberships',
        element: <AdherentMemberships />,
      },
    ],
  },
  {
    path: '/admin',
    element: (
      <AuthGuard>
        <RoleGuard requiredRoles={['admin']}>
          <AdminLayout />
        </RoleGuard>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/admin/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'roles',
        element: <RolesPage />,
      },
      {
        path: 'permissions',
        element: <PermissionsPage />,
      },
      {
        path: 'homepage-content',
        element: <HomepageContent />,
      },

      {
        path: 'info',
        element: <InfoPage />,
      },
      {
        path: 'albums',
        element: <AlbumListPage />,
      },
      {
        path: 'albums/create',
        element: <AlbumCreatePage />,
      },
      {
        path: 'albums/:id/upload',
        element: <AlbumUploadPage />,
      },
      {
        path: 'evenements',
        element: <EvenementListPage />,
      },
      {
        path: 'evenements/create',
        element: <EvenementFormPage />,
      },
      {
        path: 'evenements/:id/edit',
        element: <EvenementFormPage />,
      },
      {
        path: 'adhesions',
        element: <AdhesionListPage />,
      },
      {
        path: 'presentation',
        element: <PresentationEditPage />,
      },
    ],
  },
]);
